import AutomaticElementReloader from './automatic-element-reloader';

const RELOAD_ATTACHMENT_INTERVAL = 10000;

export default class ProxyAttachmentReloader extends AutomaticElementReloader {
  constructor(element) {
    super(element, {intervalDelay: RELOAD_ATTACHMENT_INTERVAL});
  }

  handleAJAXsuccess(data) {
    super.handleAJAXsuccess(...arguments);

    if (data) {
      this.unbindEvents();
      this.$element.replaceWith(data);
    }
  }

  handleAJAXfailure() {
    super.handleAJAXfailure(...arguments);
    this.unbindEvents();
  }
}
